import { useEffect, useState, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomTab, Select } from "../../atomicComponents";
import BackButton from "../../clientComponents/BackButton/BackButton";
import { APILimit, AUTH_CODE, deviceAsnListTableHeader, DispatchFilter, path_Operation } from "../../constants/constVariables";
import { downloadData } from "../../constants/Utils";
import { deviceAsnApi } from "../../utils/apiServices";
import DataNotFound from "../DataNotFound";
import { ErrorModal, SuccessModal, WarningModal } from "../FormComponents";
import FormModal from "../FormComponents/FormModal";
import Loader from "../Loader";
import { getPlantValue, postUsageAnalyticsCall } from "../../constants/Utils";
import Table from "../Table/Table";
import clsx from 'clsx';
import { useAuthorizationContext } from "../../providers/AuthorizationHandler/AuthorizationHandler";

const DeviceAssignment = () => {

    const { user } = useAuthorizationContext();
    const location = useLocation();
    const [loader, setLoader] = useState(false);
    const [selectCount, setSelectCount] = useState(0);
    const [checkedState, setCheckedState] = useState([]);
    const [checkedStateAll, setCheckedStateAll] = useState(false);
    const [totalData, setTotalData] = useState("00");
    const [hasNext, sethasNext] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [offset, setOffset] = useState(0);
    const [deviceList, setDeviceDataList] = useState([{}]);
    const [allSelectedRows, setAllSelectedRows] = useState(false);
    const [currentFilter, setcurrentFilter] = useState("all");
    const [pageLeaveTime, setPageLeaveTime] = useState();
    const countRef = useRef(0);  // for calculating offset

    const navigate = useNavigate();
    // const createDeviceRedirect = (() => {
    //     navigate("/device-master/add-new-device");
    // })
    const browserBack = () => {
        navigate("/");
    }
    const handleSingleCheckbox = (position, e) => {

        setCheckedState(prev => {
            let a = [];
            if (prev.length === 0) {
                deviceList.map((item, index) => index === position ? a.push(true) : a.push(false))
            }
            else {
                prev.map((item, index) =>
                    index === position ? a.push(!item) : a.push(item)
                )
            }
            return [...a];
        });
    };
    const handleCheckbox = () => {
        setCheckedStateAll(prev => { return !prev });
    }

    const increaseOffset = useCallback(() => {
        // setOffset(offset + 1);
        setOffset(prev => prev + 1);
    }, [offset]);

    const resetOffset = useCallback(() => {
        setOffset(0)
    }, [offset]);

    const increaseRef = useCallback(() => {
        countRef.current = countRef.current + 1
    }, [countRef]);

    const resetConfigs = () => {
        setSelectedRows([]);
        countRef.current = 0
        resetOffset()
    }
    const filterPlantName = getPlantValue();
    const fetchDeviceList = async () => {
        const response = await deviceAsnApi(APILimit, offset, filterPlantName.value, currentFilter);
        // console.log("response = ", response.data.data)
        var ab = {}
        // var data = response.data.data.map(function (obj, index) {
        //     return Object.assign({}, obj, {
        //         reset_pin: <ResetPinRender data_value={obj} index={index} />
        //     });
        // })
        // console.log("data = ", data, ab)
        setLoader(true);
        increaseOffset();
        increaseRef();
        sethasNext(response?.data?.has_next);
        setSelectedRows([...selectedRows, ...new Array(response.data.data.length).fill(false)])
        setCheckedState([...selectedRows, ...new Array(response.data.data.length).fill(false)])
        if (offset !== 0) {
            let temp = [...deviceList]
            response.data.data.forEach(element => {
                temp.push(element)
            });
            setDeviceDataList(temp);
            setTotalData(temp.length);
        } else {
            setDeviceDataList(response.data.data);
            setTotalData(response.data.data.length);
        }
    };

    useEffect(() => {
        fetchDeviceList()
        setPageLeaveTime(new Date())
    }, [])
    useEffect(() => {
        return () => {
            if (new Date() - pageLeaveTime) {
                const a = path_Operation?.filter((d, i) => {
                    return d?.name == location?.pathname
                })
                postUsageAnalyticsCall(user?.name, user?.userID, a[0]?.pageName ? a[0]?.pageName : location?.pathname, pageLeaveTime, a[0]?.operation ? a[0]?.operation : 'view', (new Date() - pageLeaveTime))
            }
        }
    }, [pageLeaveTime])
    useEffect(() => { resetConfigs(); fetchDeviceList() }, [currentFilter]);
    useEffect(() => {
        // console.log("offset = ", offset)
        if (countRef.current === 0) {
            fetchDeviceList();
        }
    }, [offset]);
    const updateSetSelectedRows = async (pos, data, ind) => {
        // console.log("pos = ", pos)
        if (pos == "all") {
            // console.log("pos in parent = ", pos, ind, data)
            setAllSelectedRows(!allSelectedRows)
            // console.log("allSelectedRows",allSelectedRows)
            var ab = deviceList.map((row, index) => {
                if (ind.includes(index + 1)) {
                    return !allSelectedRows
                }
                return allSelectedRows
            })
            // console.log(" = ", ab)
            setSelectedRows(ab)
        }
        else {
            setSelectedRows(prev => {
                let a = [];
                prev.map((item, index) =>
                    index === pos ? a.push(!item) : a.push(item)
                )
                // console.log("a",a);
                return [...a];
            });
        }
    }
    useEffect(() => {
        setCheckedState(prev => {
            return [...new Array(deviceList.length).fill(checkedStateAll)];
        });
    }, [checkedStateAll])
    useEffect(() => {
        setSelectCount(checkedState.filter(value => value === true).length)
    }, [checkedState])
    const handleFilterValue = (value) => {
        setcurrentFilter(value.value);
    }
    return (
        <>
            {loader ?
                <>
                    <div className='breadcrumb'>
                        <BackButton action={"Assigned Devices"} handleClick={browserBack} />
                    </div>
                    <div className="headerwithcount">
                        <div className='countdiv'>
                            <CustomTab
                                isSelected={false}
                                title={"Assigned Devices"}
                                count={totalData}
                            />
                        </div>
                        <div className="blankdiv">
                            <span className='blankdiv-title mediumFont'>
                                {/* {"All Dispatched Vehicle (Last 30 Days History)"} */}
                            </span>
                            <div style={{ marginRight: '10px' }}>
                                <Select title={"dispatchDropdown"} options={DispatchFilter} onChange={handleFilterValue} selectClassName={"dispatch-history-header-dropdown"} />
                            </div>

                        </div>

                    </div>
                    <div className="table-container">
                        <div className="table-main" >
                            <Table
                                columns={[...deviceAsnListTableHeader]}
                                defaultColumns={[...deviceAsnListTableHeader]}
                                rowHeight={38}
                                rows={deviceList}
                                secondaryActions={[
                                    {
                                        name: "Download CSV",
                                        actionFn: () => downloadData(selectedRows, deviceList, "Assigned_Devices"),
                                        backgroundColor: '#82C1A7',
                                        shouldEnable: true,
                                        authOperation: AUTH_CODE?.DOWNLOAD,
                                    }
                                ]}
                                // setAsnCount={setCount}
                                removeRowSelection={false}
                                pagination={false}
                                infiniteScroll={false}
                                actionButtons
                                hasNext={hasNext}
                                loadMoreData={() => fetchDeviceList()}
                                onClickPath=""
                                setTotalData={setTotalData}
                                selectedRows={selectedRows}
                                updateSetSelectedRows={updateSetSelectedRows}
                                selectCount={selectCount}
                                handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
                                handleCheckbox={(e) => handleCheckbox(e)}
                            />
                        </div>
                    </div>
                    <style jsx="true">
                        {`
                         a {
                            text-decoration: none;
                            color: inherit;
                          }
                .horizontal-line{
                    margin: 1rem 0 0;
                }
                .toggle-main {
                    display: flex;
                    gap: 0.5rem;
                    align-items: center;
                    padding-left: 10px;
                }
                .toggle-text{
                    font-family: Open Sans;               
                    font-weight: 700;
                    line-height: 22px;
                    letter-spacing: 0em;
                    text-align: center;
                    color: #4e4e4e;
                }
                .toggle-text.right{
                    margin-left:0.25rem;
                }
                .switch input {
                    position: absolute;
                    opacity: 0;
                  }
                  .switch {
                    display: flex;
                    align-items: center;
                    height: 8px;
                    width: 30px;
                    background: transparent;
                    border-radius: 1em;
                    border: 2px solid #2E75B5;
                    cursor: pointer;
                  }
                  .switch div {
                    height: 20px;
                    width: 20px;
                    border-radius: 50%;
                    background: #2E75B5;
                    box-shadow: 0 0.1em 0.3em rgba(0,0,0,0.3);
                    -webkit-transform: translate3d(-5px, 0, 0);
                       -moz-transform: translate3d(-5px, 0, 0);
                            transform: translate3d(-5px, 0, 0);
                    -webkit-transition: all 300ms;
                       -moz-transition: all 300ms;
                            transition: all 300ms;
                  }
                  .switch input:checked + div {
                    -webkit-transform: translate3d(calc(100% - 5px), 0, 0);
                       -moz-transform: translate3d(calc(100% - 5px), 0, 0);
                            transform: translate3d(calc(100% - 5px), 0, 0);
                  }
                .reset_pin{
                    font-weight: 600;
                    font-size: var(--mediumFontSize);
                    line-height: var(--mediumFontSize);
                    display: flex;
                    align-items: center;
                    text-decoration-line: underline;
                    background: transparent;
                    color: #82C1A7;
                    border: none;
                    cursor: pointer;
                    padding: 0;
                }
                .reset_pin_container{
                    display: flex;
                    flex-direction: column;
                }
                .disabled{
                    color: #B3B3B3;
                    cursor: unset;
                    text-decoration-line: none;
                    display: flex;
                    align-items: center;
                }
                .reset_pin_container_heading{
                    font-weight: 400;
                    font-size: var(--mediumFontSize);
                    line-height: 22px;
                    align-items: center;
                    color: #707070;
                    display: flex;
                    justify-content: center;
                    padding-bottom: 0.5rem
                }
                .reset_pin_container_pin{
                    font-weight: 600;
                    font-size: var(--xxlargeFontSize);
                    letter-spacing: 1rem;
                    line-height: 44px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    text-transform: uppercase;
                    color: #707070;
                }
                .device_resetTimer{
                    font-size: var(--mediumFontSize);
                    line-height: 22px;
                }
                @media only screen and (max-width: 1440px) {
                    .horizontal-line{
                        margin: 0.5rem 0 0;
                    }
                }
                @media only screen and (max-width: 768px) {
                    .table-container-footer, .dashboard-footer {
                        bottom: 3rem;
                    }
                    .dispatch-map-inner{
                        flex-direction: column;
                    }
                    .dispatch-map{
                        width: 100%;
                        height: 40rem;
                    }
                    .dispatch-footer{
                        flex-direction: column;
                        gap: 1rem;
                    }
                    .dispatch-table-container{
                        display: none;
                    }
                    .toggle-main {
                        display: none;
                    }
                }
                /* Dont move it to any css file, keep it here only */
                @media only screen and (max-width: 768px) {
                    .mob-secondary-navbar{
                        width: calc(100% - 2rem);
                        position: fixed;
                        left: 0;
                        top: 0;
                    }
                    .mob-secondary-header{
                        display: flex;
                        // background: #F3F5F9;
                        align-items: center;
                        justify-content: space-between;
                        padding: 0.25rem 1rem;
                        font-weight: 600;                        
                        line-height: 19px;
                        color: #707070;
                        width: 100%;
                    } 
                    .mob-header-heading{
                        display: flex;
                        align-items: center;
                        white-space: nowrap;
                    }
                    .mob-header-heading img{
                        height: 20px;
                        margin-right: 0.5rem;
                    }
                    .mobile-card-container{
                        margin-top: 1rem;
                    }
                   
                }
                `}
                    </style>
                </>
                : <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Loader />
                </div>}
        </>
    );

}
export default DeviceAssignment